import script from "./burtonDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./burtonDashboard.vue?vue&type=script&setup=true&lang=js"

import "./burtonDashboard.vue?vue&type=style&index=0&id=33bb4aa9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33bb4aa9"]])

export default __exports__